/* #46 通貨の参考価格。ドルの文字列や決済額は読み書きしない。 */
(function () {
  'use strict';
  if (window.nkCurrencyRef) {
    window.nkCurrencyRef.init(document);
    return;
  }

  var node = document.getElementById('nk-cur-data');
  if (!node) { console.warn('nk-currency-ref: 設定要素がありません'); return; }
  var data;
  try { data = JSON.parse(node.textContent); } catch (error) { console.warn('nk-currency-ref: 設定JSONを読み取れません'); return; }
  if (!data || !data.rates || !data.fmt) { console.warn('nk-currency-ref: 設定にratesまたはfmtがありません'); return; }

  var labels = {usd: 'USD\u00a0$', eur: 'EUR\u00a0€', gbp: 'GBP\u00a0£',
    cad: 'CAD\u00a0C$', aud: 'AUD\u00a0A$', chf: 'CHF', hkd: 'HKD\u00a0HK$', aed: 'AED'};
  var states = new WeakMap();
  var carts = new WeakSet();
  var selects = new WeakSet();
  var storageFailed = false;
  var current = readCurrency();

  function available(code) {
    if (code === 'usd') return true;
    var fmt = data.fmt[code];
    return Object.prototype.hasOwnProperty.call(labels, code)
      && Object.prototype.hasOwnProperty.call(data.rates, code)
      && Number.isFinite(data.rates[code]) && data.rates[code] > 0
      && fmt && typeof fmt.p === 'string' && typeof fmt.s === 'string';
  }

  function readCurrency() {
    var saved;
    // 保存を拒否されたときも、タブを戻しただけで画面内の選択を失わない。
    if (storageFailed && available(current)) return current;
    try { saved = window.localStorage.getItem('nk_cur'); } catch (error) {
      storageFailed = true;
      if (available(current)) return current;
    }
    return available(saved) ? saved : (available(data.default) ? data.default : 'usd');
  }

  function each(root, selector, callback) {
    if (root.matches && root.matches(selector)) callback(root);
    root.querySelectorAll(selector).forEach(callback);
  }

  function freshData() {
    return Number.isFinite(data.expires) && data.expires * 1000 > Date.now();
  }

  function format(cents, code) {
    if (!Number.isSafeInteger(cents) || cents < 0 || code === 'usd' || !available(code) || !freshData()) return '';
    // 既存の4桁レートの計算を継承し、四捨五入の境界で小数誤差を避ける。
    var scaled = cents * Math.round(data.rates[code] * 10000);
    if (!Number.isSafeInteger(scaled)) return '';
    return data.fmt[code].p + String(Math.round(scaled / 1000000)).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + data.fmt[code].s;
  }

  function centsFrom(raw) {
    return /^\d+$/.test(raw || '') ? Number(raw) : NaN;
  }

  function displayCurrency() {
    return freshData() ? current : 'usd';
  }

  function renderMark(state) {
    var code = displayCurrency();
    var fmt = data.fmt[code] || {p: '', s: ''};
    state.button.dataset.rate = code === 'usd' ? '0' : String(data.rates[code]);
    state.button.dataset.prefix = fmt.p;
    state.button.dataset.suffix = fmt.s;
    state.button.dataset.expires = String(data.expires);
    var amount = format(centsFrom(state.button.dataset.priceCents), code);
    if (!amount || state.emptyCart) { invalidate(state); return; }
    state.amount.textContent = amount;
    state.button.hidden = false;
  }

  function render(root) {
    // 保存した選択は残し、期限切れの間だけ表示をUSDに揃える。
    var code = displayCurrency();
    document.documentElement.setAttribute('data-nk-cur', code);
    each(root, '[data-nk-cur-ref]', function (element) {
      var amount = format(centsFrom(element.dataset.nkCents), code);
      element.textContent = amount ? '(' + amount + ')' : '';
    });
    each(root, '[data-nk-cur-pill]', function (element) { element.textContent = labels[code]; });
    each(root, '[data-nk-cur-select]', function (select) { select.value = code; });
    eachState(root, renderMark);
    document.documentElement.classList.remove('nk-cur-pending');
  }

  function eachState(root, callback) {
    each(root, '.nk-cref__mk', function (button) {
      var state = states.get(button);
      if (state) callback(state);
    });
  }

  function fresh(state) {
    var expires = Number(state.button.dataset.expires);
    return Number.isFinite(expires) && expires * 1000 > Date.now();
  }

  function setOpen(state, open) {
    open = Boolean(open && !state.button.hidden && fresh(state));
    state.button.setAttribute('aria-expanded', open ? 'true' : 'false');
    state.button.setAttribute('aria-label', open
      ? state.button.dataset.hideLabel : state.button.dataset.showLabel);
    state.line.hidden = !open;
    // hiddenを外した初期状態を確定し、不透明度だけを120msで変える。
    if (open) void state.line.offsetWidth;
    state.line.dataset.open = open ? '1' : '';
  }

  function invalidate(state) {
    setOpen(state, false);
    state.button.hidden = true;
  }

  function syncCart(cart) {
    var items = cart.querySelector('[data-products] .cart__items[data-cart-subtotal]');
    if (!items) return;
    var raw = items.dataset.cartSubtotal;
    var cents = /^\d+$/.test(raw || '') ? Number(raw) : NaN;
    eachState(cart, function (state) {
      state.emptyCart = items.dataset.count === '0';
      // USDで隠れている間も、最新の小計セントを保持する。
      state.button.dataset.priceCents = String(cents);
      renderMark(state);
    });
  }

  function init(root) {
    root = root || document;
    each(root, '[data-nk-cur-select]', function (select) {
      if (selects.has(select)) return;
      selects.add(select);
      select.addEventListener('change', function () {
        current = available(select.value) ? select.value : (available(data.default) ? data.default : 'usd');
        try { window.localStorage.setItem('nk_cur', current); } catch (error) { storageFailed = true; }
        render(document);
      });
    });
    each(root, '.nk-cref__mk', function (button) {
      if (states.has(button)) return;
      // 箱＝価格の行（商品）または小計の行（カート）。行は印の隣に無ければ箱の中から探す
      // （カートでは行を小計の行の2段目に置くため）。closest はカンマ区切りを使わず2回に分ける。
      var box = button.closest('.nk-product__pricerow') || button.closest('.nk-cart__subtotal') || button.parentElement;
      var line = button.nextElementSibling;
      if (!line || !line.classList || !line.classList.contains('nk-cref__line')) {
        line = box && box.querySelector ? box.querySelector('.nk-cref__line') : null;
      }
      if (!line) return;
      var amount = line.querySelector('[data-nk-cref-amount]');
      if (!amount) return;
      var state = {button: button, line: line, amount: amount, box: box};
      states.set(button, state);
      setOpen(state, false);
      if (!fresh(state)) invalidate(state);
      // Enter / Space は本物のbuttonが生成するclickに任せ、二重反転を防ぐ。
      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (!fresh(state)) invalidate(state);
        else setOpen(state, button.getAttribute('aria-expanded') !== 'true');
      });
    });

    each(root, '.nk-cart', function (cart) {
      var products = cart.querySelector('[data-products]');
      if (!products || carts.has(cart)) return;
      carts.add(cart);
      // 数量変更とcart:buildの両方で差し替わる実物の数値属性を使う。
      new MutationObserver(function () { syncCart(cart); })
        .observe(products, {childList: true});
      syncCart(cart);
    });
    render(root);
  }

  document.addEventListener('click', function (event) {
    eachState(document, function (state) {
      if (!state.box.contains(event.target)) setOpen(state, false);
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') eachState(document, function (state) { setOpen(state, false); });
  });
  document.addEventListener('shopify:section:load', function () { init(document); });
  document.addEventListener('collection:reloaded', function () { init(document); });
  document.addEventListener('nk:cards-added', function () { init(document); });
  function resume() {
    current = readCurrency();
    init(document);
    eachState(document, function (state) {
      setOpen(state, false);
      if (!fresh(state)) invalidate(state);
    });
  }
  window.addEventListener('pageshow', resume);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) resume();
  });
  window.nkCurrencyRef = {init: init, refresh: init};
  // 開いたまま期限を迎えたカードも、同じ時点ですべて消す。
  if (freshData()) window.setTimeout(function () { render(document); }, data.expires * 1000 - Date.now());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
